<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="library.length"
        badge-classes="bg-success"
        class="text-body"
        icon="BookOpenIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t('Library') }}
        </h4>
        <b-badge
          pill
          variant="success"
        >
          {{ library.length }} {{ $t('new') }}
        </b-badge>
      </div>
    </li>

    <!-- Library -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >

      <b-link
        v-for="(book,index) in library"
        :key="index"
        class="d-flex"
        @click="readLibrary(book)"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="book.variant"
            >
              <feather-icon :icon="book.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ book.title }}
            </span>
          </p>
          <small class="notification-text">{{ formatDate(book.createDate) }}

          </small>

        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="allLibrary"
      >{{ $t('Show all library') }}</b-button>
    </li>

  </b-nav-item-dropdown>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    userLevel: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      userData: null,
      library: [],
      readItem: null,
    }
  },
  mounted() {
    this.$root.$on('refresh_library', () => {
      this.getLibrary()
    })
  },
  beforeDestroy() {
    this.$root.$off('refresh_library')
  },
  created() {
    this.getLibrary()
  },
  methods: {
    allLibrary() {
      this.$router.push({ name: 'library', params: { } })
    },
    formatDate(date) {
      return dayjs(date).fromNow()
    },
    readLibrary(book) {
      this.$root.$emit('read_library', book)
    },
    getLibrary() {
      useJwt.axiosIns.get('library/new')
        .then(response => {
          if (response.data) {
            this.library = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
  setup() {
    /* eslint-disable global-require */

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>
